// extracted by mini-css-extract-plugin
module.exports = {"hero-content":"taxi-booking_hero-content__dkbRu","hero":"taxi-booking_hero__4vRwH","hero-bg":"taxi-booking_hero-bg__CTed_"};